/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { Checkbox, Text } from '@chakra-ui/core';
import { Permission } from './teamPermission.interface';
import colors from '../../../../styles/colors';

interface CheckboxInputProps extends Permission {
  value: boolean;
  onChange: (value: boolean) => void;
}
export default function TeamPermissionCheckbox({ title, description, key, value, onChange }: CheckboxInputProps) {
  return (
    <Checkbox
      value={key}
      isChecked={value}
      colorScheme="blue"
      onChange={(e) => {
        onChange(e.target.checked);
      }}
    >
      <Text color={colors.gray[500]} fontSize="sm">
        <strong>{title}</strong> - {description}
      </Text>
    </Checkbox>
  );
}
